import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
//pages
import Main from "./pages/Dashboard";
import LandingPage from "./pages/landingpage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndCondition from "./pages/TermsAndCondition";
import Refund from "./pages/Refundpolicy";
import History from "./pages/History";
import HistoryView from "./pages/HistoryPreview";
import Result from "./pages/Generatepage";
import NotFoundPage from "./pages/NotFoundPage";
import Buypage from "./pages/Buypremium";

//forms
import CreateDefault from "./forms/createLegalDoc";
import CriminalCharges from "./forms/CriminalCharge";
import NonCriminal from "./forms/NonCriminalCertificat";
import EmployeeContract from "./forms/EmployeeContract";
import LeaseAgreement from "./forms/LeaseAgreement";
import PropertyOwnership from "./forms/PropertyOwnership";
import AiAssistant from "./forms/Legalassistant";
import CaseAnalyser from "./forms/CaseAnalyser";

//helper
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactGA from "react-ga4";
import { getAnalytics, logEvent } from "firebase/analytics";
import Templates from "./pages/templates";
import TemplatePreview from "./pages/TemplatePreview";
function App() {
  useEffect(() => {
    if (
      window.location.pathname === "/about" ||
      window.location.pathname === "/login"
    ) {
      window.location.href = "*";
    }
  }, []);
  const initializeGA = () => {
    const id = process.env.REACT_APP_GA4_TRACKING_ID;
    if (id) ReactGA.initialize(id);
  };

  const logPageView = (path) => {
    ReactGA.send({ hitType: "pageview", page: path });
  };

  const gaTrackingId = process.env.REACT_APP_GOOGLE_ANALYITCS_ID;

  useEffect(() => {
    if (gaTrackingId) {
      initializeGA(gaTrackingId);
    }
  }, []);

  useEffect(() => {
    const setRealVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--real-vh', `${vh}px`);
    };
  
    setRealVh();
    window.addEventListener('resize', setRealVh);
    return () => window.removeEventListener('resize', setRealVh);
  }, []);

  useEffect(() => {
    logPageView(window.location.pathname);

    const analytics = getAnalytics();
    logEvent(analytics, "page_view", {
      label: window.location.pathname,
    });
  }, [window.location.pathname]);

  return (
    <>
      <ToastContainer />

      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms&condition" element={<TermsAndCondition />} />
        <Route path="/refundpolicy" element={<Refund />} />
        <Route path="/test" element={<div>Test Works</div>} />
        <Route path="/templates" element={<Templates />} />
        <Route path="/templates/:templateName" element={<TemplatePreview />} />
        <Route path="/Dashboard" element={<Main />} />
        <Route path="/:slug" element={<CreateDefault />} />
        <Route
          path="/criminal-charges-templates"
          element={<CriminalCharges />}
        />
        <Route
          path="/employment-contract-templates"
          element={<EmployeeContract />}
        />
        <Route path="/lease-agreement-templates" element={<LeaseAgreement />} />
        <Route
          path="/property-ownership-templates"
          element={<PropertyOwnership />}
        />
        <Route
          path="/non-criminal-certificate-templates"
          element={<NonCriminal />}
        />
        <Route path="/ai-assistant" element={<AiAssistant />} />
        <Route path="/case-analyzer" element={<CaseAnalyser />} />
        <Route path="/history" element={<History />} />
        <Route path="/result" element={<Result />} />
        <Route path="/premium" element={<Buypage />} />
        <Route path="/history-view" element={<HistoryView />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

export default App;
